import { render, staticRenderFns } from "./DepartmentDropdown.vue?vue&type=template&id=75889c89&"
import script from "./DepartmentDropdown.vue?vue&type=script&lang=js&"
export * from "./DepartmentDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports